import React, { useState, useEffect } from "react";
import axios from "axios";
import { AppBar, useTheme, useMediaQuery } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { headerIntegration as headerIntegrationRedux } from "../../../../redux";
import { useStyles } from "./styles";
import TopMenu from "./TopMenu";
import MiddleSection from "./MiddleSection";
import MainMenu from "./MainMenu";
import MobileHeader from "./MobileHeader";
import parseTitle from "./ParseTitle";

const Header = ({ logo, client, user, shoppingCarts }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const menuData = useSelector((state) => state.headerIntegration.value);
  const commerce = useSelector((state) => state.setting.settingCommerce);
  const systemTheme = useSelector((state) => state.theme.systemTheme);
  const theme = useTheme({ theme: systemTheme });
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [loading, setLoading] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activePopover, setActivePopover] = useState(null);
  const [error, setError] = useState(null);
  const [retryCount, setRetryCount] = useState(0);
  const MAX_RETRIES = 3;

  useEffect(() => {
    const fetchMenu = () => {
      axios
        .get(commerce?.link_integracao_site)
        .then((response) => {
          dispatch(
            headerIntegrationRedux.actions.setHeaderIntegration(response.data)
          );
          setError(null);
        })
        .catch((error) => {
          console.error("Erro ao buscar o menu:", error);
          setError(error);
          if (retryCount < MAX_RETRIES) {
            setTimeout(() => {
              setRetryCount((prev) => prev + 1);
              fetchMenu();
            }, Math.pow(2, retryCount) * 1000);
          }
        })
        .finally(() => setLoading(false));
    };

    if (commerce?.link_integracao_site) {
      fetchMenu();
    }
  }, [commerce?.link_integracao_site]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  if (isMobile) {
    return (
      <MobileHeader
        logo={logo}
        client={client}
        user={user}
        shoppingCarts={shoppingCarts}
        classes={classes}
        handleDrawerToggle={handleDrawerToggle}
        mobileOpen={mobileOpen}
        menuData={menuData}
        parseTitle={parseTitle}
      />
    );
  }

  return (
    <AppBar className={classes.header}>
      {logo && (
        <a className={classes.logo} href="/">
          <img alt={`Logo da ${client}`} src={logo} />
        </a>
      )}
      <TopMenu
        menu={menuData?.menu_topo}
        classes={classes}
        parseTitle={parseTitle}
        loading={loading}
      />
      <MiddleSection
        menuData={menuData}
        classes={classes}
        parseTitle={parseTitle}
        loading={loading}
        activePopover={activePopover}
        setActivePopover={setActivePopover}
        user={user}
        shoppingCarts={shoppingCarts}
      />
      <MainMenu
        menu={menuData?.menu_principal}
        classes={classes}
        parseTitle={parseTitle}
        loading={loading}
        activePopover={activePopover}
        setActivePopover={setActivePopover}
      />
    </AppBar>
  );
};

export default Header;
